import React from 'react';
import {CompanyTable} from "../components";
import NomenclatureTable from "../components/NomenclatureTable";
import UserTable from "../components/UserTable";
import {Box, Flex, Grid, Text, useBreakpointValue} from "@chakra-ui/react";
import CompanySettings from "../components/CompanySettings";

const SettingsView = () => {
    const gridTemplateColumns = useBreakpointValue({
        base: "1fr",
        md: "1fr 1fr",
    });

    return (
        <Flex p="4" pt="0" direction="column" gap="50">
            <Grid templateColumns={gridTemplateColumns} gap="20px">
                <Box borderBottom="1px solid" borderColor="gray.200" p="5" pt="0" overflowX="auto">
                    <Text pb="3" pt="3" fontWeight="bold" borderBottom="1px solid" borderColor="gray.300">
                        Detalii Utilizatori
                    </Text>
                    <UserTable/>
                </Box>

                <Box borderBottom="1px solid" borderColor="gray.200" p="5" pt="0" overflowX="auto">
                    <Text pb="3" pt="3" fontWeight="bold" borderBottom="1px solid" borderColor="gray.300">
                        Setări Inchidere de lună
                    </Text>
                    <CompanySettings/>
                </Box>
            </Grid>

            <Box borderBottom="1px solid" borderColor="gray.200" p="5" pt="0" overflowX="auto">
                <Text pb="3" pt="3" fontWeight="bold" borderBottom="1px solid" borderColor="gray.300">
                    Detalii Organizații
                </Text>
                <CompanyTable/>
            </Box>

            <Box borderBottom="1px solid" borderColor="gray.200" p="5" pt="0" overflowX="auto">
                <Text pb="3" pt="3" fontWeight="bold" borderBottom="1px solid" borderColor="gray.300">
                    Sincronizare manuală nomenclatoare OMC
                </Text>
                <NomenclatureTable/>
            </Box>
        </Flex>
    );
};

export default SettingsView;

